import { tns } from 'tiny-slider/src/tiny-slider';
import {
	shouldAutoplaySlider,
	wireTnsAutoplayToggle,
} from '../util/slider-autoplay-toggle';

class StatsSlider {
	/**
	 * StatsSlider constructor
	 *
	 * @param {HTMLElement} el The posts list element
	 * @param {HTMLElement|null} nav
	 * @param {Object} options
	 */
	constructor(el, nav, options = {}) {
		this.root = el.closest('.block-stats');
		this.sliderSelector = el.classList.contains('stats__stat-slider--columns')
			? '.stats__stat-slider--columns'
			: '.stats__stat-slider:not(.stats__stat-slider--columns)';
		this.navSelector = nav?.classList.contains('custom-nav-container-stats--columns')
			? '.custom-nav-container-stats--columns'
			: '.custom-nav-container-stats';
		this.el = el;
		this.nav = nav;
		this.instance = null;
		this.mobileOnly = Boolean(options.mobileOnly);
		this.tnsOptions = { ...options };
		delete this.tnsOptions.mobileOnly;

		if (this.mobileOnly) {
			this.mq = window.matchMedia('(max-width: 799px)');
			this.onMqChange = () => this.syncMobileOnly();
			this.syncMobileOnly();

			if (this.mq.addEventListener) {
				this.mq.addEventListener('change', this.onMqChange);
			} else {
				this.mq.addListener(this.onMqChange);
			}

			return this;
		}

		this.instance = this.create(this.tnsOptions);
		return this.instance;
	}

	getElements() {
		if (!this.root) {
			return { el: this.el, nav: this.nav, autoplayToggle: null };
		}

		return {
			el: this.root.querySelector(this.sliderSelector),
			nav: this.root.querySelector(this.navSelector),
			autoplayToggle: this.root.querySelector('[data-slider-autoplay-toggle]'),
		};
	}

	create(tnsOptions = {}) {
		const { el, nav, autoplayToggle } = this.getElements();

		if (!el) {
			return null;
		}

		this.el = el;
		this.nav = nav;

		const defaults = {
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: 'gallery',
			autoplay: shouldAutoplaySlider(),
			autoplayButtonOutput: false,
			speed: 400,
			controls: false,
			nav: true,
			navPosition: 'bottom',
			navContainer: this.nav,
		};

		const instance = tns({
			...defaults,
			...tnsOptions,
			autoplay: shouldAutoplaySlider(),
			autoplayButtonOutput: false,
		});

		wireTnsAutoplayToggle(instance, autoplayToggle);

		return instance;
	}

	syncMobileOnly() {
		if (this.mq.matches) {
			if (!this.instance) {
				this.instance = this.create({
					mode: 'carousel',
					...this.tnsOptions,
				});
			}
			return;
		}

		this.destroyInstance();
	}

	destroyInstance() {
		if (!this.instance || typeof this.instance.destroy !== 'function') {
			this.instance = null;
			return;
		}

		this.instance.destroy();
		this.instance = null;

		// destroy() replaces markup via outerHTML — refresh refs for the next init
		const { el, nav } = this.getElements();
		this.el = el;
		this.nav = nav;
	}
}

export default StatsSlider;
